unit Unit4;

interface

uses
  SysUtils, Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls,
  WEBLib.ExtCtrls, WEBLib.CDS, DB, WEBLib.DB,
  WEBLib.Buttons;

type
  TForm4 = class(TForm)
    WebLabel1: TLabel;
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form4: TForm4;

implementation


procedure TForm4.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  try
    Name := 'Form4';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 72;
    WebLabel1.Width := 105;
    WebLabel1.Height := 22;
    WebLabel1.Caption := 'Finansowanie';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := 22;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.ParentFont := False;
  finally
    WebLabel1.AfterLoadDFMValues;
  end;
end;

end.